export default __webpack_public_path__ + "static/media/MULTI.203788bf.png";